export default __webpack_public_path__ + "static/media/complete_engineering_manufacturing_solutions.27317751.png";